import Reveal from "../Reveal";

export const FounderCard = ({ founder, index, image }) => (
  <Reveal
    delay={index * 120}
    className={`relative ${index === 1 ? "md:translate-y-16" : ""}`}
    data-testid={index === 0 ? "founder-riccardo" : "founder-sasha"}
  >
    <div className="relative overflow-hidden card-flat aspect-[4/5]">
      <img
        src={image}
        alt={founder.name}
        className="w-full h-full object-cover img-mono"
      />
      <div className="absolute top-4 md:top-6 left-4 md:left-6 overline bg-white/80 backdrop-blur px-3 py-1 rounded-full">
        {founder.badge}
      </div>
    </div>
    <div className="mt-6 md:mt-8">
      <h2 className="font-display text-4xl md:text-5xl lg:text-6xl tracking-tightest">
        {founder.name}
      </h2>
      <div className="overline mt-3">{founder.role}</div>
      <p className="mt-4 md:mt-6 text-[14px] md:text-[15px] text-ink-500 leading-relaxed max-w-lg">
        {founder.bio}
      </p>
      <div className="mt-5 md:mt-6 flex flex-wrap gap-2">
        {founder.focus.map((tt) => (
          <span
            key={tt}
            className="text-[10px] md:text-[11px] font-mono tracking-[0.18em] uppercase px-3 py-1.5 border border-ink-200 rounded-full text-ink-700"
          >
            {tt}
          </span>
        ))}
      </div>
    </div>
  </Reveal>
);
